import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'dealhunt — Compare PC Game Prices Across 21 Stores',
      description: 'Compare PC game prices across 21 digital stores including Steam, Epic Games Store, and GOG. Track deals, build a wishlist, and get price-drop alerts with dealhunt.'
    }
  },
  {
    path: '/browser',
    name: 'browser',
    component: () => import (/* webpackChunkName: "browser" */ '../views/BrowserView.vue'),
    meta: {
      title: 'Browse Deals — dealhunt',
      description: 'Search and filter game deals across 21 stores by title, store, price range, and savings percentage.'
    }
  },
  {
    path: '/wishlist',
    name: 'wishlist',
    component: () => import (/* webpackChunkName: "wishlist" */ '../views/WishlistView.vue'),
    meta: {
      title: 'Wishlist — dealhunt',
      description: 'View your saved games and set price alerts to get notified when they go on sale.'
    }
  },
  {
    path: '/guide',
    name: 'guide',
    component: () => import (/* webpackChunkName: "guide" */ '../views/GuideView.vue'),
    meta: {
      title: 'User Guide — dealhunt',
      description: 'Learn how to use dealhunt to compare PC game prices, build a wishlist, and set price-drop alerts across 21 digital stores.'
    }
  },
  {
    path: '/game/:dealID',
    name: 'game',
    component: () => import (/* webpackChunkName: "game" */ '../views/GameView.vue'),
    meta: {
      title: 'Deal Details — dealhunt',
      description: 'Full deal details, price history, and multi-store price comparison.'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach(to => {
  document.title = to.meta?.title || 'dealhunt — Compare PC Game Prices Across 21 Stores'

  const description = to.meta?.description
  if (description) {
    let tag = document.querySelector('meta[name="description"]')
    if (!tag) {
      tag = document.createElement('meta')
      tag.setAttribute('name', 'description')
      document.head.appendChild(tag)
    }
    tag.setAttribute('content', description)
  }
})

export default router
